import React, { useState, useEffect, useContext } from "react";
import apiCalls from "shared/utils/apiCalls";
import Grid from "@material-ui/core/Grid";
import styles from "./TopUsers.module.scss";
import { Link } from "react-router-dom";
import Badge from "shared/components/Badge/Badge";
import Skeleton from "@material-ui/lab/Skeleton";
import { ReducerTypes } from "shared/types/reducerTypes";
import AppContext from "context/AppContext";

const TopUsers = () => {
  const { state, dispatch } = useContext(AppContext);
  const [loading, setLoading] = useState<boolean>();

  const getRecentBadges = async () => {
    const res = await apiCalls({
      method: "get",
      url: `/user-badges`,
    });

    if (res) {
      dispatch({
        type: ReducerTypes.getRecentBadges,
        payload: { value: res.data },
      });
    }
  };

  useEffect(() => {
    if (state.recentBadges) {
      return;
    }
    getRecentBadges();
    // eslint-disable-next-line
  }, []);

  const getTopUsers = async () => {
    setLoading(true);
    const res = await apiCalls({
      method: "get",
      url: `/users/reputations`,
    });

    if (res) {
      dispatch({
        type: ReducerTypes.getTopUsers,
        payload: { value: res.data },
      });
    }

    setLoading(false);
  };

  useEffect(() => {
    if (state.topUsers) {
      return;
    }

    getTopUsers();
    // eslint-disable-next-line
  }, []);

  if (loading) {
    return (
      <>
        <h2>Top Users</h2>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={9}>
            {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((number) => (
              <div key={number} style={{ marginBottom: "var(--space-xl)" }}>
                <Skeleton key={number} height={70} variant="rect" />
              </div>
            ))}
          </Grid>
        </Grid>
      </>
    );
  }

  return (
    <div className={styles.topUsers}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={9}>
          <h2>Top Users</h2>

          <div className={styles.topUsers_userPanel}>
            {state.topUsers?.map(
              (
                { name, picture, reputations, feedbacks, id, solutions }: any,
                index: any
              ) => (
                <Link
                  to={`/profile/${id}`}
                  style={{
                    textDecoration: "none",
                  }}
                  className={styles.topUsers_userPanel_card}
                  key={id}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={4} sm={1}>
                      <img
                        src={picture}
                        className={styles.topUsers_userPanel_card_img}
                        alt={name}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={8}
                      sm={5}
                      className={styles.topUsers_userPanel_reputations}
                    >
                      <div className={styles.topUsers_userPanel_card_name}>
                        {name}{" "}
                        <b className={styles.topUsers_userPanel_card_rank}>
                          #{index + 1}
                        </b>
                      </div>
                      <div
                        className={styles.topUsers_userPanel_card_reputations}
                      >
                        {reputations} reputations
                      </div>
                    </Grid>

                    <Grid
                      container
                      item
                      xs={12}
                      sm={6}
                      className={styles.topUsers_userPanel_card_summary}
                    >
                      <Grid
                        item
                        xs={6}
                        className={styles.topUsers_userPanel_card_summary_item}
                      >
                        <div
                          className={
                            styles.topUsers_userPanel_card_summary_item_number
                          }
                        >
                          {feedbacks || 0}
                        </div>
                        <div>feedback</div>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        className={styles.topUsers_userPanel_card_summary_item}
                      >
                        <div
                          className={
                            styles.topUsers_userPanel_card_summary_item_number
                          }
                        >
                          {solutions.length}
                        </div>
                        <div>solutions</div>
                      </Grid>
                    </Grid>
                  </Grid>
                </Link>
              )
            )}
          </div>
        </Grid>

        <Grid item xs={12} sm={3}>
          <div className={styles.topUsers_summary}>
            <h4>Recent Badges</h4>

            {state.recentBadges && state.recentBadges.length < 1 && (
              <h6 style={{ color: "var(--grey-5)" }}>No Badges Found</h6>
            )}

            {state.recentBadges &&
              state.recentBadges.map(
                ({ type, label, category, name, userId, id }: any) => (
                  <div className={styles.topUsers_recentUserBadge} key={id}>
                    <Link to={`/profile/${userId}`}>{name}</Link>

                    <Badge type={type} label={label} category={category} />
                  </div>
                )
              )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default TopUsers;
